import { Box, Button, Typography } from '@mui/material';
import { infoModalSxs } from 'src/content/billing/components/newChangePlan';
import {
  DesignerPlanText, pro, expert, AgencyPlanText,
  planNames, freePlanDowngradeCancelButtonTextForDeactivate, infoModalTexts,
  starter,
  starterPlus,
  diy,
  expertPlus
} from 'src/common/config/TextMessage';
import { localSeoTexts } from 'src/content/localSeo/localSeoTexts';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

interface DeactivateActionsProps {
  activePlanName: string;
  handCloseModal: () => void;
  handleContinue: () => void;
}

const DeactivateActions = ({ activePlanName, handCloseModal, handleContinue }: DeactivateActionsProps) => {
  const stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const isOldPlan = stripeSubscriptionDetails?.planVersion == 'v1'

  const getStayWithText = () => {
    if (!activePlanName) return freePlanDowngradeCancelButtonTextForDeactivate;
    const upperPlan = activePlanName.toUpperCase();
    if (upperPlan === DesignerPlanText?.toUpperCase()) return ` ${pro} `;
    if (upperPlan === AgencyPlanText?.toUpperCase()) return ` ${expert} `;
    if (upperPlan === expertPlus?.toUpperCase()) return ` ${expertPlus} `;
    if (upperPlan === starter?.toUpperCase() || upperPlan === diy?.toUpperCase() || upperPlan === planNames?.starterPlus?.toUpperCase()) {
      if (upperPlan === planNames?.starterPlus?.toUpperCase()) return ` ${starterPlus} `;
      return ` ${isOldPlan ? diy : starter} `;
    }
    if (upperPlan === planNames?.localseo?.toUpperCase()) return ` ${localSeoTexts?.localSeo} `;
    return ` ${activePlanName} `;
  };

  return (
    <Box sx={infoModalSxs?.freeDowngradeBtnBox}>
      <Button fullWidth variant="contained" onClick={handCloseModal} sx={infoModalSxs?.freeDowngradeStayBtn}>
        <Typography sx={{ ...infoModalSxs?.stayOnBtnText, color: 'var(--color-white)' }}>
          {activePlanName && infoModalTexts?.stayWith}{getStayWithText()}
        </Typography>
      </Button>
      <Button fullWidth variant="outlined" onClick={handleContinue} sx={infoModalSxs?.freeDowngradeStayBtn}>
        <Typography sx={{ ...infoModalSxs?.stayOnBtnText, color: 'var(--color-primary)' }}>
          {infoModalTexts?.continue}{' '}
        </Typography>
      </Button>
    </Box>
  );
};

export default DeactivateActions;
